import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_WORK_TIME_LIST,
  SET_WORK_TIME_PAGE_STATUS,
  SET_WORK_TIME_EDIT_MODAL_DATA,
  GET_WORK_TIME_EDIT_MODAL_DATA,
} = SYSTEMSETTING;

const initialState = {
  tableListData: {
    data: [],
    total: 0,
  }, // table数据
  pageStatus: {
    pageNum: 1,
    pageSize: 20,
  }, // pageNum与pageSize
  editModalData: {
    id: '',
    data: {},
  }, // 编辑弹框数据
};

const workTime = (state = initialState, action) => {
  switch (action.type) {
    case `${GET_WORK_TIME_LIST}_SUCCESS`:
      return {
        ...state,
        tableListData: {
          data: (action.payload.data && action.payload.data.list) || [],
          total: (action.payload.data && action.payload.data.total) || 0,
        },
      };
    case `${GET_WORK_TIME_LIST}_FAIL`:
      return {
        ...state,
        tableListData: {
          data: [],
          total: 0,
        },
      };
    case `${SET_WORK_TIME_PAGE_STATUS}`:
      return {
        ...state,
        pageStatus: {...state.pageStatus, ...action.data},
      };
    case `${SET_WORK_TIME_EDIT_MODAL_DATA}`:
      return {
        ...state,
        editModalData: {...state.editModalData, ...action.data},
      };

    case `${GET_WORK_TIME_EDIT_MODAL_DATA}_SUCCESS`:
      return {
        ...state,
        editModalData: {
          ...state.editModalData,
          data: {...action.payload.data},
        },
      };
    default:
      return state;
  }
};

export default workTime;
